module.exports = __webpack_public_path__ + "img/gj_7.27a79709.jpg";